import { createAction, props } from "@ngrx/store";
import { LearningRecordTabActionTypes } from "src/app/constants/StoreConstants";
import { LearnerLearningRecord } from "src/app/_models/LearnerLearningRecord";

export const SetSelectedCourse = createAction(
    LearningRecordTabActionTypes.SetSelectedCourse,
    props<{courseId: number}>()
);

export const SetTabState = createAction(
    LearningRecordTabActionTypes.SetTabState,
    props<{state: LearnerLearningRecord[], courseId: number}>()
);

export const UpdateTabState = createAction(
    LearningRecordTabActionTypes.UpdateTabState,
    props<{ objectId: string, skill: string }>()
);

export const UpdateTabStateSuccess = createAction(
    LearningRecordTabActionTypes.UpdateTabStateSuccess
);

export const SetSelectedCourseSuccess = createAction(
    LearningRecordTabActionTypes.SetSelectedCourseSuccess
);

export const SetTabStateSuccess = createAction(
    LearningRecordTabActionTypes.SetTabStateSuccess
);

export const GetLearningRecord = createAction(
    LearningRecordTabActionTypes.GetLearningRecord,
    props<{courseId: number}>()
);

export const GetLearningRecordByLearnerId = createAction(
    LearningRecordTabActionTypes.GetLearningRecordByLearnerId,
    props<{learnerId: number, courseId: number}>()
);

export const GetLearningRecordError = createAction(
    LearningRecordTabActionTypes.GetLearningRecordError
);

export const ResetPanelState = createAction(
    LearningRecordTabActionTypes.ResetPanelState
);